var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C8 1.37014 7.7989 1.69331 7.5 1.86622V2H12C12.5523 2 13 2.44772 13 3V4C13.5523 4 14 4.44772 14 5V9C14 9.55228 13.5523 10 13 10V11C13 11.5523 12.5523 12 12 12H2C1.44772 12 1 11.5523 1 11V10C0.447715 10 0 9.55228 0 9V5C0 4.44772 0.447715 4 1 4V3C1 2.44772 1.44772 2 2 2H6.5V1.86622C6.2011 1.69331 6 1.37014 6 1C6 0.447715 6.44772 0 7 0C7.55228 0 8 0.447715 8 1ZM4.5 7C5.32843 7 6 6.32843 6 5.5C6 4.67157 5.32843 4 4.5 4C3.67157 4 3 4.67157 3 5.5C3 6.32843 3.67157 7 4.5 7ZM11 5.5C11 6.32843 10.3284 7 9.5 7C8.67157 7 8 6.32843 8 5.5C8 4.67157 8.67157 4 9.5 4C10.3284 4 11 4.67157 11 5.5ZM4 8C3.44772 8 3 8.44771 3 9C3 9.55228 3.44772 10 4 10H10C10.5523 10 11 9.55228 11 9C11 8.44771 10.5523 8 10 8H4Z",
    fill: "#212D41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.bcdb1692ebf60ef1a828c6291dcc88cb.svg";
export { ForwardRef as ReactComponent };